"use strict";
'use es6';

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = InteractionWithNavigationConfirmation;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _I18n = _interopRequireDefault(require("I18n"));

var _react = _interopRequireWildcard(require("react"));

var _InteractionDescriptorRecord = _interopRequireDefault(require("customer-data-communicator/schema/communicator/interaction/config/InteractionDescriptorRecord"));

var _ComponentMethods = require("customer-data-ui-utilities/component/ComponentMethods");

var _NavigationConfirmation = require("customer-data-ui-utilities/navigation/NavigationConfirmation");

var _InteractionWithNavigationConfirmationComponentConfig = _interopRequireDefault(require("customer-data-communicator/schema/wrappers/InteractionWithNavigationConfirmationComponentConfig"));

var _PureComponent2 = _interopRequireDefault(require("customer-data-ui-utilities/component/PureComponent"));

var _emptyFunction = _interopRequireDefault(require("react-utils/emptyFunction"));

/*
  Adds Navigation Confirmation support to an interaction. The user will receive a confirm prompt if the interaction content is
  savable. Handles autosaving the interaction record if there had been a call in progress (we need to save call notes event if
  the user navigates away)
*/
var propTypes = {
  children: _react.PropTypes.node,
  descriptor: _react.PropTypes.instanceOf(_InteractionDescriptorRecord.default).isRequired,
  handleNavigationTriggered: _react.PropTypes.func
};
var defaultProps = {
  handleNavigationTriggered: _emptyFunction.default
};

function InteractionWithNavigationConfirmation() {
  var componentConfig = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : (0, _InteractionWithNavigationConfirmationComponentConfig.default)();
  return function (InteractionComponent) {
    var InteractionWithNavigationConfirmationComponent =
    /*#__PURE__*/
    function (_PureComponent) {
      (0, _inherits2.default)(InteractionWithNavigationConfirmationComponent, _PureComponent);

      function InteractionWithNavigationConfirmationComponent(props) {
        var _this;

        (0, _classCallCheck2.default)(this, InteractionWithNavigationConfirmationComponent);
        _this = (0, _possibleConstructorReturn2.default)(this, (0, _getPrototypeOf2.default)(InteractionWithNavigationConfirmationComponent).call(this, props));
        (0, _ComponentMethods.bindHandlers)((0, _assertThisInitialized2.default)(_this));
        return _this;
      }

      (0, _createClass2.default)(InteractionWithNavigationConfirmationComponent, [{
        key: "componentWillMount",
        value: function componentWillMount() {
          (0, _NavigationConfirmation.register)(this.handleGetNavigationConfirmation);
        }
      }, {
        key: "componentWillUnmount",
        value: function componentWillUnmount() {
          (0, _NavigationConfirmation.unregister)(this.handleGetNavigationConfirmation);
        }
      }, {
        key: "handleGetNavigationConfirmation",
        value: function handleGetNavigationConfirmation() {
          var type = this.props.descriptor.type;
          var abandonChangesPromptKey = componentConfig.abandonChangesPromptKey;
          this.props.handleNavigationTriggered();

          if (this.showPreventNavigation) {
            return _I18n.default.text(abandonChangesPromptKey, {
              objectType: type
            });
          }

          return null;
        }
      }, {
        key: "handlePreventNavigation",
        value: function handlePreventNavigation(showPreventNavigation) {
          this.showPreventNavigation = showPreventNavigation;
        }
      }, {
        key: "render",
        value: function render() {
          return _react.default.createElement(InteractionComponent, (0, _extends2.default)({}, this.props, {
            onPreventNavigation: this.handlePreventNavigation
          }), this.props.children);
        }
      }]);
      return InteractionWithNavigationConfirmationComponent;
    }(_PureComponent2.default);

    InteractionWithNavigationConfirmationComponent.propTypes = propTypes;
    InteractionWithNavigationConfirmationComponent.defaultProps = defaultProps;
    return InteractionWithNavigationConfirmationComponent;
  };
}

module.exports = exports.default;